<template>
  <slot v-if="$apolloData.loading" name="is-loading" />
  <slot v-else-if="enabled" />
  <slot v-else name="is-disabled" />
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'FeatureFlagged',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      featureFlagData: null,
    }
  },
  apollo: {
    featureFlagData: {
      query: gql`
        query featureFlagQuery($name: String!) {
          featureFlagData: featureFlag(name: $name) {
            enabled
          }
        }
      `,
      variables() {
        return { name: this.name }
      },
      update(data) {
        this.$emit('enabled-updated', data.featureFlagData.enabled)
      },
      result({ data }) {
        this.featureFlagData = data?.featureFlagData
      },
    },
  },
  computed: {
    enabled() {
      return this.featureFlagData?.enabled ?? false
    },
  },
}
</script>
